<template>
  <section class="pageContents">
    <div class="pageContents-text container">
      <Tests />
    </div>
  </section>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import Tests from '@/components/tests.vue';

@Options({
    name: 'TestsView',
    components: {
        Tests,
    },
    props: {
      msg: String
    },
    emits: {
        //select: (myProperty: string) => typeof myProperty === 'string'
    },
  })
export default class TestsView extends Vue {}
</script>
